module.exports = __webpack_public_path__ + "img/content12.7f305742.png";